module.exports = __webpack_public_path__ + "img/Nauru.b5239d74.svg";